import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import BaseFormPage from "../../../../../base/BaseFormPage";
import NavBar from "../../../../../components/navbar";
import TransferHistoryFormPresenter from "./TransferHistoryFormPresenter";

class TransferHistoryFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false, selectedRawIds: [] };
    this.presenter = new TransferHistoryFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
  }

  getCollectionName() {
    return "stock_transfers";
  }

  render() {
    const object = this.state.object;
    console.log("object", object);
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label =
      this.getObjectId() === undefined ? "Add " : "View Transfer Logs ";
    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h2
                  className="fw-bold mt-3 text-capitalize"
                  style={{ color: "#82c14a" }}
                >
                  <i
                    onClick={() => this.navigateBack()}
                    className="bi bi-chevron-compact-left"
                    style={{ color: "black", cursor: "pointer" }}
                  ></i>
                  {
                    label
                    // (schema.label || toDisplayCase(this.getCollectionName()))
                  }
                </h2>
              </div>

              <div
                className="mt-2 shadow rounded p-3 px-lg-5 py-lg-4"
                style={{ backgroundColor: "#f6f5fa" }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <h6></h6>
                  {object?.id && (
                    <span
                      className="px-3 py-1 fw-semibold"
                      style={{
                        backgroundColor: "#ffcd29", // yellow
                        borderRadius: "999px",
                        color: "#212529", // dark text
                        fontSize: "0.875rem",
                        border: "1px solid #d6a500",
                      }}
                    >
                      Current Status: {object?.status}
                    </span>
                  )}
                </div>

                <hr />
                {object?.logsArray?.length > 0 && (
                  // <div className="mt-4">
                  //   <h5 className="text-primary fw-bold mb-3">Status Update</h5>
                  //   <div className="border rounded px-4 py-3 bg-white">
                  //     {object.logsArray
                  //       .slice() // shallow copy
                  //       .reverse() // show latest on top
                  //       .map((log, index) => (
                  //         <div
                  //           key={index}
                  //           className="d-flex justify-content-between align-items-center mb-2"
                  //         >
                  //           <span
                  //             className=""
                  //             style={{ color: "#6c757d", fontSize: "0.9rem" }}
                  //           >
                  //             {log?.timestamp &&
                  //               new Date(log?.timestamp).toLocaleString(
                  //                 "en-US",
                  //                 {
                  //                   month: "long", // March
                  //                   day: "numeric", // 2
                  //                   year: "numeric", // 2025
                  //                   hour: "numeric", // 5
                  //                   minute: "2-digit", // 15
                  //                   hour12: true, // am/pm
                  //                 }
                  //               )}
                  //           </span>
                  //           <span
                  //             className="fw-bold"
                  //             style={{
                  //               color:
                  //                 log.status === "Done"
                  //                   ? "green"
                  //                   : log.status === "For Dispatch"
                  //                   ? "orange"
                  //                   : log.status === "Cancelled"
                  //                   ? "red"
                  //                   : "black",
                  //             }}
                  //           >
                  //             {log.status}
                  //           </span>
                  //         </div>
                  //       ))}
                  //   </div>
                  // </div>
                  <div className="mt-4">
                    {/* Modern Header with Icon */}
                    {/* <div className="d-flex align-items-center gap-3 mb-4">
                      <div
                        className="rounded-3 d-flex align-items-center justify-content-center"
                        style={{
                          width: "48px",
                          height: "48px",
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
                        }}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="2.5"
                        >
                          <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <div>
                        <h5
                          className="mb-0 fw-bold"
                          style={{ color: "#2d3748" }}
                        >
                          Status Timeline
                        </h5>
                        <p className="mb-0 text-muted small">
                          Track your transfer progress
                        </p>
                      </div>
                    </div> */}
                    <div className="d-flex align-items-center gap-3 mb-4">
                      <div
                        className="rounded-3 d-flex align-items-center justify-content-center position-relative"
                        style={{
                          width: "56px",
                          height: "56px",
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          boxShadow: "0 8px 16px rgba(102, 126, 234, 0.4)",
                        }}
                      >
                        {/* Rotating ring animation */}
                        <div
                          className="position-absolute rounded-3"
                          style={{
                            width: "56px",
                            height: "56px",
                            border: "3px solid rgba(255, 255, 255, 0.3)",
                            animation: "rotate 3s linear infinite",
                          }}
                        />
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="2.5"
                        >
                          <path d="M3 3h18v18H3zM3 9h18M9 21V9" />
                        </svg>
                      </div>
                      <div>
                        <h5
                          className="mb-0 fw-bold"
                          style={{ color: "#2d3748" }}
                        >
                          Activity Timeline
                        </h5>
                        <p className="mb-0 text-muted small">
                          Track your transfer progress
                        </p>
                      </div>
                    </div>

                    {/* Timeline Container */}
                    <div
                      className="rounded-4 p-4 position-relative"
                      style={{
                        background:
                          "linear-gradient(to bottom, #ffffff 0%, #f8f9fa 100%)",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                        border: "1px solid #e9ecef",
                      }}
                    >
                      {object.logsArray.length > 0 ? (
                        <div className="position-relative">
                          {/* Vertical Timeline Line */}
                          <div
                            className="position-absolute"
                            style={{
                              left: "23px",
                              top: "0",
                              bottom: "0",
                              width: "3px",
                              background:
                                "linear-gradient(to bottom, #667eea 0%, #e9ecef 100%)",
                              borderRadius: "10px",
                            }}
                          />

                          {object.logsArray
                            .slice()
                            .reverse()
                            .map((log, index) => {
                              // Determine status color and icon
                              const statusConfig = {
                                Done: {
                                  color: "#10b981",
                                  bgColor: "#d1fae5",
                                  icon: (
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="#10b981"
                                      strokeWidth="3"
                                    >
                                      <path d="M5 13l4 4L19 7" />
                                    </svg>
                                  ),
                                },
                                "For Dispatch": {
                                  color: "#f59e0b",
                                  bgColor: "#fef3c7",
                                  icon: (
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="#f59e0b"
                                      strokeWidth="2.5"
                                    >
                                      <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                  ),
                                },
                                Cancelled: {
                                  color: "#ef4444",
                                  bgColor: "#fee2e2",
                                  icon: (
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="#ef4444"
                                      strokeWidth="3"
                                    >
                                      <path d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                  ),
                                },
                              };

                              const config = statusConfig[log.status] || {
                                color: "#6b7280",
                                bgColor: "#f3f4f6",
                                icon: (
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#6b7280"
                                    strokeWidth="2.5"
                                  >
                                    <circle cx="12" cy="12" r="10" />
                                  </svg>
                                ),
                              };

                              const isLatest = index === 0;

                              return (
                                <div
                                  key={index}
                                  className="position-relative mb-4 pb-3"
                                  style={{
                                    paddingLeft: "60px",
                                    transition: "all 0.3s ease",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateX(5px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  {/* Timeline Dot */}
                                  <div
                                    className="position-absolute d-flex align-items-center justify-content-center rounded-circle"
                                    style={{
                                      left: "12px",
                                      top: "8px",
                                      width: "24px",
                                      height: "24px",
                                      background: "white",
                                      border: `3px solid ${config.color}`,
                                      boxShadow: isLatest
                                        ? `0 0 0 4px ${config.bgColor}`
                                        : "none",
                                      zIndex: 1,
                                    }}
                                  >
                                    {isLatest && (
                                      <div
                                        className="position-absolute rounded-circle"
                                        style={{
                                          width: "8px",
                                          height: "8px",
                                          background: config.color,
                                          animation: "pulse 2s infinite",
                                        }}
                                      />
                                    )}
                                  </div>

                                  {/* Status Card */}
                                  <div
                                    className="rounded-3 p-3 shadow-sm"
                                    style={{
                                      background: "white",
                                      border: `1px solid ${isLatest ? config.color : "#e9ecef"}`,
                                      borderLeft: `4px solid ${config.color}`,
                                      transition: "all 0.3s ease",
                                    }}
                                  >
                                    <div className="d-flex justify-content-between align-items-start gap-3">
                                      {/* Status Info */}
                                      <div className="flex-grow-1">
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                          <div
                                            className="rounded-2 d-flex align-items-center justify-content-center"
                                            style={{
                                              width: "28px",
                                              height: "28px",
                                              background: config.bgColor,
                                            }}
                                          >
                                            {config.icon}
                                          </div>
                                          <span
                                            className="fw-bold"
                                            style={{
                                              color: config.color,
                                              fontSize: "1.05rem",
                                            }}
                                          >
                                            {log.status}
                                          </span>
                                          {isLatest && (
                                            <span
                                              className="badge rounded-pill px-2 py-1"
                                              style={{
                                                background: config.bgColor,
                                                color: config.color,
                                                fontSize: "0.7rem",
                                                fontWeight: "600",
                                              }}
                                            >
                                              Current
                                            </span>
                                          )}
                                        </div>

                                        {/* Timestamp */}
                                        <div className="d-flex align-items-center gap-2">
                                          <svg
                                            width="14"
                                            height="14"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#9ca3af"
                                            strokeWidth="2"
                                          >
                                            <circle cx="12" cy="12" r="10" />
                                            <path d="M12 6v6l4 2" />
                                          </svg>
                                          <span
                                            className="text-muted"
                                            style={{ fontSize: "0.85rem" }}
                                          >
                                            {log?.timestamp &&
                                              new Date(
                                                log?.timestamp,
                                              ).toLocaleString("en-US", {
                                                month: "long",
                                                day: "numeric",
                                                year: "numeric",
                                                hour: "numeric",
                                                minute: "2-digit",
                                                hour12: true,
                                              })}
                                          </span>
                                        </div>
                                        {/* Remarks */}
                                        {log?.remarks && (
                                          <div className="d-flex align-items-start gap-2">
                                            <svg
                                              width="14"
                                              height="14"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="#9ca3af"
                                              strokeWidth="2"
                                              style={{ marginTop: "2px", flexShrink: 0 }}
                                            >
                                              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                            </svg>
                                            <span
                                              className="text-muted"
                                              style={{ fontSize: "0.85rem" }}
                                            >
                                              {log.remarks}
                                            </span>
                                          </div>
                                        )}
                                        {/* Files Upload */}
                                        {log?.attachments?.length > 0 && (
                                          <div className="d-flex align-items-start gap-2">
                                            <svg
                                              width="14"
                                              height="14"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="#9ca3af"
                                              strokeWidth="2"
                                              style={{ marginTop: "2px", flexShrink: 0 }}
                                            >
                                              <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                                            </svg>
                                            <div className="d-flex flex-wrap gap-1">
                                              {log.attachments.map((url, i) => {
                                                const fileName = decodeURIComponent(
                                                  url.split("/").pop().replace(/^[a-f0-9]+_/, "")
                                                );
                                                const ext = fileName.split(".").pop().toLowerCase();
                                                const isImage = ["png", "jpg", "jpeg", "gif", "webp", "svg"].includes(ext);
                                                const isPdf = ext === "pdf";
                                                const isExcel = ["xlsx", "xls", "csv"].includes(ext);
                                                const isDoc = ["doc", "docx"].includes(ext);
                                                const chipStyle = isImage
                                                  ? { color: "#9333ea", background: "#faf5ff", border: "1px solid #f3e8ff", hoverBg: "#f3e8ff" }
                                                  : isPdf
                                                  ? { color: "#dc2626", background: "#fef2f2", border: "1px solid #fee2e2", hoverBg: "#fee2e2" }
                                                  : isExcel
                                                  ? { color: "#16a34a", background: "#f0fdf4", border: "1px solid #dcfce7", hoverBg: "#dcfce7" }
                                                  : isDoc
                                                  ? { color: "#2563eb", background: "#eff6ff", border: "1px solid #dbeafe", hoverBg: "#dbeafe" }
                                                  : { color: "#6366f1", background: "#eef2ff", border: "1px solid #e0e7ff", hoverBg: "#e0e7ff" };
                                                return (
                                                  <a
                                                    key={i}
                                                    href={url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="d-inline-flex align-items-center gap-1"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      color: chipStyle.color,
                                                      background: chipStyle.background,
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                      textDecoration: "none",
                                                      border: chipStyle.border,
                                                    }}
                                                    onMouseOver={(e) => e.currentTarget.style.background = chipStyle.hoverBg}
                                                    onMouseOut={(e) => e.currentTarget.style.background = chipStyle.background}
                                                  >
                                                    {isImage ? (
                                                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                                        <circle cx="8.5" cy="8.5" r="1.5" />
                                                        <polyline points="21 15 16 10 5 21" />
                                                      </svg>
                                                    ) : isPdf ? (
                                                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                                        <polyline points="14 2 14 8 20 8" />
                                                        <line x1="16" y1="13" x2="8" y2="13" />
                                                        <line x1="16" y1="17" x2="8" y2="17" />
                                                      </svg>
                                                    ) : isExcel ? (
                                                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                                        <polyline points="14 2 14 8 20 8" />
                                                        <line x1="8" y1="13" x2="16" y2="13" />
                                                        <line x1="8" y1="17" x2="16" y2="17" />
                                                        <line x1="12" y1="9" x2="12" y2="21" />
                                                      </svg>
                                                    ) : isDoc ? (
                                                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                                        <polyline points="14 2 14 8 20 8" />
                                                        <line x1="16" y1="13" x2="8" y2="13" />
                                                        <line x1="16" y1="17" x2="8" y2="17" />
                                                        <line x1="10" y1="9" x2="8" y2="9" />
                                                      </svg>
                                                    ) : (
                                                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                                        <polyline points="14 2 14 8 20 8" />
                                                      </svg>
                                                    )}
                                                    {fileName}
                                                  </a>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      ) : (
                        // Empty State
                        <div className="text-center py-5">
                          <div
                            className="mx-auto rounded-circle d-flex align-items-center justify-content-center mb-3"
                            style={{
                              width: "80px",
                              height: "80px",
                              background:
                                "linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)",
                            }}
                          >
                            <svg
                              width="40"
                              height="40"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#9ca3af"
                              strokeWidth="2"
                            >
                              <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </div>
                          <h6 className="text-muted mb-1">No Status Updates</h6>
                          <p className="text-muted small mb-0">
                            Status updates will appear here
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Add this style tag or include in your CSS */}
                    <style>{`
    @keyframes pulse {
      0%, 100% {
        opacity: 1;
        transform: scale(1);
      }
      50% {
        opacity: 0.5;
        transform: scale(1.2);
      }
    }
  `}</style>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(TransferHistoryFormPage);
